import Toast from './Toast.vue'

const globalComponents = {
  Toast
}

export default globalComponents
